import React, { Component } from 'react';
import _ from 'lodash';

import DepartmentGroupTable from '../DepartmentGroupTable';

class ForwardSecretary extends Component {
  constructor(){
    super();

    this.state = {
      current_form: "note",
      department_group_id: null,
      informee_text: "",
      department_group_name: "",
      department_group_members: "",
      note_text: "",
    }

    this.openDepartmentGroupModal = this.openDepartmentGroupModal.bind(this);
    this.handleSelectDepartmentGroup = this.handleSelectDepartmentGroup.bind(this);
    this.clearDepartmentGroup = this.clearDepartmentGroup.bind(this);
    this.setInformeeText = this.setInformeeText.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setNoteText = this.setNoteText.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  openDepartmentGroupModal(){
    this.setState({current_form: "selectDepartmentGroup"});
  }

  handleSelectDepartmentGroup(row, isSelected, e){
    this.setState({
      department_group_id: row.id,
      informee_text: row.informee_name,
      department_group_name: row.name,
      department_group_members: row.member_name_with_positions,
      current_form: "note",
    });
  }

  clearDepartmentGroup(row, isSelected, e){
    this.setState({
      department_group_id: "",
      informee_text: "",
      department_group_name: "",
      department_group_members: "",
      current_form: "note",
    });
  }

  handleSubmit(){
    this.props.onSubmitAction(this.state.note_text, this.state.department_group_id);
  }

  setInformeeText(event){
    const informee_text = event.target.value;
    this.setState({informee_text: informee_text});
  }

  setNoteText(event){
    const note_text = event.target.value;
    this.setState({note_text: note_text});
  }

  handleClose(){
    this.setState({current_form: "note"});
  }

  render(){
    return(
      <div>
        { this.state.current_form === 'note' && (
          <div>
            <div className="row">
              <div className="col-2">เรียน</div>
              <div className="col-10">
                <input type="text" className="form-control from-control-sm mb-2" value={this.state.informee_text} onChange={this.setInformeeText} />
              </div>
            </div>
            <div className="row">
              <div className="col-2">ผู้ดำเนินการ</div>
              <div className="col-10">
                {this.state.department_group_name && (
                  <div className="card mb-1">
                    <div className="card-body">
                      <h4>{this.state.department_group_name}</h4>
                      {_.map(this.state.department_group_members, function(member, index){
                        return(
                          <div key={index} className="green-border green-text p-1 mb-1">
                            {member}
                          </div>
                        )
                      })}
                      <i  className='fa fa-times close-icon text-danger' 
                          onClick={() => this.clearDepartmentGroup()}>
                      </i>
                    </div>
                  </div>
                )}

                <button className="btn btn-sm btn-primary" onClick={this.openDepartmentGroupModal}>เลือกผู้ดำเนินการ</button>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <h4>เพื่อดำเนินการ</h4>
                <textarea cols="30" rows="10" className="w-100" value={this.state.note_text} onChange={this.setNoteText}></textarea>
              </div>
            </div>

            <div className="modal-footer row mt-2">
              <button type='button' className="btn btn-primary pointer" disabled={this.props.clicked} onClick={this.handleSubmit}>ยืนยัน</button>
              <button type='button' className="btn btn-secondary pointer" onClick={this.props.onCloseModal}>ยกเลิก</button>
            </div>
          </div>
        )}
        { this.state.current_form === 'selectDepartmentGroup' && (
          <div>
            <nav className="mb-1">
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <a className="nav-item nav-link show active" id="nav-internal-tab" data-toggle="tab" href="#nav-internal" role="tab" aria-controls="nav-internal" aria-selected="true">
                  สารบรรณหน่วยงาน
                </a>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div className="tab-pane fade show active" id="nav-internal" role="tabpanel" aria-labelledby="nav-internal-tab">
                <DepartmentGroupTable department_groups={this.props.department_groups}
                                      onSelect={this.handleSelectDepartmentGroup}
                                      onClose={this.handleClose} />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default ForwardSecretary;


// WEBPACK FOOTER //
// ./src/components/WorkflowActions/ForwardSecretary.js